import { rootRoute } from "./tanstack_routes/__root";
import { mainOfferRoute } from "./tanstack_routes/checkout/$checkoutPath";
import { confirmationRoute } from "./tanstack_routes/checkout/$checkoutPath/confirmation/$sessionId";
import { offerRoute } from "./tanstack_routes/checkout/$checkoutPath/step/$stepId";

export const paywallCheckoutRouteTree = rootRoute.addChildren([
  mainOfferRoute,
  offerRoute,
  confirmationRoute,
]);
